import React from "react"
import { Icon, Modal, SignInControl, LegalFooter } from "@fider/components"
import SignsIOLogo from "@fider/assets/images/signsio-logo.svg"
import { CloseIcon } from "./common"
import { Trans } from "@lingui/react/macro"
import { HStack, VStack } from "./layout"

interface SignInModalProps {
  isOpen: boolean
  onClose: () => void
}

export const SignInModal: React.FC<SignInModalProps> = (props) => {
  const onCodeVerified = (): void => {
    // User is authenticated - close modal and reload to refresh the page
    props.onClose()
    location.reload()
  }

  return (
    <Modal.Window isOpen={props.isOpen} onClose={props.onClose}>
      <Modal.Header>
        <VStack spacing={8}>
          <HStack justify="between">
            <span role="img" aria-label="サインアイオー">
              <Icon sprite={SignsIOLogo} height="24" width="61" />
            </span>
            <CloseIcon closeModal={props.onClose} />
          </HStack>
          <h2 className="text-center">
            <Trans id="modal.signin.signsio.header">Sign in to Signs I/O</Trans>
          </h2>
        </VStack>
      </Modal.Header>
      <Modal.Content>
        <SignInControl useEmail={true} onCodeVerified={onCodeVerified} />
      </Modal.Content>
      <LegalFooter />
    </Modal.Window>
  )
}
